/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassScheduleEntry
 */
export interface ClassScheduleEntry {
    /**
     * 
     * @type {Date}
     * @memberof ClassScheduleEntry
     */
    start: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClassScheduleEntry
     */
    end: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClassScheduleEntry
     */
    sessionDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ClassScheduleEntry
     */
    sessionStartTime: string;
    /**
     * 
     * @type {string}
     * @memberof ClassScheduleEntry
     */
    sessionEndTime: string;
}

/**
 * Check if a given object implements the ClassScheduleEntry interface.
 */
export function instanceOfClassScheduleEntry(value: object): value is ClassScheduleEntry {
    if (!('start' in value) || value['start'] === undefined) return false;
    if (!('end' in value) || value['end'] === undefined) return false;
    if (!('sessionDate' in value) || value['sessionDate'] === undefined) return false;
    if (!('sessionStartTime' in value) || value['sessionStartTime'] === undefined) return false;
    if (!('sessionEndTime' in value) || value['sessionEndTime'] === undefined) return false;
    return true;
}

export function ClassScheduleEntryFromJSON(json: any): ClassScheduleEntry {
    return ClassScheduleEntryFromJSONTyped(json, false);
}

export function ClassScheduleEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassScheduleEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'start': (new Date(json['start'])),
        'end': (new Date(json['end'])),
        'sessionDate': (new Date(json['sessionDate'])),
        'sessionStartTime': json['sessionStartTime'],
        'sessionEndTime': json['sessionEndTime'],
    };
}

export function ClassScheduleEntryToJSON(json: any): ClassScheduleEntry {
    return ClassScheduleEntryToJSONTyped(json, false);
}

export function ClassScheduleEntryToJSONTyped(value?: ClassScheduleEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'start': value['start'].toISOString(),
        'end': value['end'].toISOString(),
        'sessionDate': value['sessionDate'].toISOString().substring(0,10),
        'sessionStartTime': value['sessionStartTime'],
        'sessionEndTime': value['sessionEndTime'],
    };
}

